import { HStack, Skeleton } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuote } from '../../../../../hooks/useQuoteQueries';
import { getOfferState } from '../../../../../services/offersService';
import { getEuroValue } from '../../../../../services/productFactoryService';
import OfferSidebarSingleSelectedOfferPrice from './OfferSidebarSingleSelectedOfferPrice';

interface SinglePreferredOfferProps {
  riskObject: string;
  preferredOfferId: string;
}

const SinglePreferredOffer: React.FC<
  React.PropsWithChildren<SinglePreferredOfferProps>
> = ({ riskObject, preferredOfferId }) => {
  const { t } = useTranslation();

  const { data: preferredOffer, isFetching } = useQuote(
    riskObject,
    preferredOfferId,
  );
  const offerState = getOfferState(preferredOffer);

  if (isFetching) return <Skeleton h="4" w="28" />;

  if (!preferredOffer)
    return (
      <HStack>
        {' '}
        <OfferSidebarSingleSelectedOfferPrice price="-" interval="-" />
      </HStack>
    );

  return (
    <HStack>
      <OfferSidebarSingleSelectedOfferPrice
        price={
          (getEuroValue(
            offerState,
            preferredOffer?.premium?.total_premium,
          ) as string) || '-'
        }
        interval={
          preferredOffer?.details?.payment_interval
            ? t(
                `spread.${preferredOffer.details.payment_interval.toUpperCase()}`,
              )
            : '-'
        }
      />
    </HStack>
  );
};

export default SinglePreferredOffer;
